import { render, staticRenderFns } from "./bscHhptAgentType.vue?vue&type=template&id=53180365&scoped=true"
import script from "./bscHhptAgentType.vue?vue&type=script&lang=js"
export * from "./bscHhptAgentType.vue?vue&type=script&lang=js"
import style0 from "./bscHhptAgentType.vue?vue&type=style&index=0&id=53180365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53180365",
  null
  
)

export default component.exports